import { FC, createContext, useState, useContext } from 'react';

export type LastPostViewedContextValue = {
  setLastPostViewedId: (postId) => void;
  lastPostViewed: number | null;
  hasNewPosts: boolean;
  onAddNewPost: () => void;
  onRemoveNewPosts: () => void;
};

const LastPostViewedContext = createContext<LastPostViewedContextValue>({
  setLastPostViewedId: () => null,
  lastPostViewed: 0,
  hasNewPosts: false,
  onAddNewPost: () => null,
  onRemoveNewPosts: () => null,
});

export const LastPostViewedProvider: FC<React.PropsWithChildren<unknown>> = (props) => {
  const { children } = props;

  const [lastPostViewed, setLastPostViewed] = useState(0);
  const [hasNewPosts, setHasNewPosts] = useState(false);

  const setLastPostViewedId = (postId: number) =>
    setLastPostViewed(postId);

  const onAddNewPost = () => setHasNewPosts(true);

  const onRemoveNewPosts = () => setHasNewPosts(false);

  return (
    <LastPostViewedContext.Provider
      value={{
        setLastPostViewedId,
        lastPostViewed,
        hasNewPosts,
        onAddNewPost,
        onRemoveNewPosts,
      }}
    >
      {children}
    </LastPostViewedContext.Provider>
  );
};

export const useLastPostViewed = () => useContext(LastPostViewedContext);

export const LastPostViewedConsumer = LastPostViewedContext.Consumer;

export default LastPostViewedContext;
